import { FaReact, FaCss3Alt } from 'react-icons/fa';
import { SiRedux } from 'react-icons/si';
import magicTrunfo from '../img/Magic-Trunfo.png';
import triviaGame from '../img/the-trivia-game.png';
import timer from '../img/timer-project.png';
import recipeApp from '../img/recipeApp.png';

const projects = [
  {
    img: recipeApp,
    title: 'Recipe App',
    description: {
      english: 'The last project of the front end module of the trybe course, developed in a group using React and Context API, was a project where we had to develop a mobile only website for food and drink recipes.',
      portuguese: 'O último projeto do modulo de front end do curso trybe, desenvolvido em grupo usando React e Context API, foi um projeto onde tivemos que desenvolver um site mobile only de receitas de comidas e bebidas.',
    },
    github: 'https://github.com/GeZudo/recipe-app',
    deploy: 'https://recipe-app.augustoalves.dev/',
    tech: [<FaReact />, <FaCss3Alt />],
  },
  {
    img: timer,
    title: 'Timer',
    description: {
      english: 'A simple timer, a challenge made during the class on the Trybe course, developed in React, a project that despite being simple is among my favorites.',
      portuguese: 'Um timer simples, desafio feito durante a aula no curso da Trybe, desenvolvido em React, um projeto que apesar de simples está dentre os meus favoritos',
    },
    github: 'https://github.com/GeZudo/trybe-timer',
    deploy: 'https://timer.augustoalves.dev/',
    tech: [<FaReact />, <FaCss3Alt />],
  },
  {
    img: triviaGame,
    title: 'Trivia Game',
    description: {
      english: 'A group project developed using React and Redux during Trybe course, a Trivia quiz game.',
      portuguese: 'Um projeto em grupo desenvolvido usando React e Redux durante o curso da Trybe, um jogo estilo Trivia.',
    },
    github: 'https://github.com/GeZudo/project-trivia',
    deploy: 'https://trivia.augustoalves.dev/',
    tech: [<FaReact />, <SiRedux />, <FaCss3Alt />],
  },
  {
    img: magicTrunfo,
    title: 'Magic Trunfo',
    description: {
      english: 'Second React project developed durings Trybe course, a Top Trumps card maker, and I chose to style ir like Magic TCG.',
      portuguese: 'Segundo projeto em React desenvolvido durante o curso da Trybe, um criador de cartas Trunfo, e eu optei por estilizar como cartas de Magic TCG',
    },
    github: 'https://github.com/GeZudo/magic-trunfo/tree/master',
    deploy: 'https://gezudo.github.io/magic-trunfo/',
    tech: [<FaReact />, <FaCss3Alt />],
  },
];

export default projects;
